import { Button, Card, Image } from 'react-bootstrap';

interface FilesCloudUploadItemProps {
    file: File;
    fileIndex?: number;
    disabled?: boolean;
    onDelete?: (index: number) => void;
}

const FilesCloudUploadItem = ({ file, fileIndex = 0, disabled = false, onDelete }: FilesCloudUploadItemProps) => {
    const fileName = file?.name || '';
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    const iconSrc = `/imgs/fileTypes/${extension}.png`;

    return (
        <li className="list-inline-item" style={{ maxWidth: '250px' }}>
            <Card className="p-1 my-1 text-truncate" style={{ borderRadius: '8px' }} title={fileName}>
                <Card.Body className="text-truncate p-0 d-flex align-items-center">
                    <Image
                        className="rounded img-fluid me-1"
                        style={{ height: '24px', padding: '2px' }}
                        onError={(ev) => ((ev.currentTarget as HTMLImageElement).src = '/imgs/fileTypes/unknown.png')}
                        src={iconSrc}
                    />
                    <span className="text-truncate fs-12" style={{ paddingRight: onDelete ? '30px' : '10px' }}>
                        {fileName}
                    </span>
                    {onDelete && (
                        <div style={{ position: 'absolute', right: '8px', opacity: '0.8' }}>
                            <Button
                                className="px-1 py-0"
                                variant="light-danger"
                                title="Delete"
                                size="sm"
                                disabled={disabled}
                                onClick={() => onDelete(fileIndex)}
                            >
                                <i className="bi bi-trash3 fs-12"></i>
                            </Button>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </li>
    );
};

export default FilesCloudUploadItem;
